module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-25-20ff2d48eb9c0b2449ac08bfba02d929.png";